import { inject, Injectable } from '@angular/core';
import {
  ContentWithNotes, 
  contentWithNotes, 
  ProductPurchaseInfo, 
  ProductWithStruct, 
  productWithStruct, 
  TransactionStatus, 
  UserProductData} from '../utils/commonTypes';
  
import {Utils} from '../utils/amplify-utils';

import { Logger } from 'tslog';
import { BackendRequest, RequestType } from '../amplify/types';
import { PaymentOperationResult, PaymentOperationStatus } from '../amplify/payment-types';
import { UserNote } from '../amplify/data-resource';
import { AmplifyService } from './amplify.service';
import { ContentUtilsService } from '../utils/content.utils';
import { lib } from 'crypto-js';
import { getEntitlementsApi } from '../utils/api/openapi-utils';


@Injectable({
  providedIn: 'root'
})

export class ProductService {
  private log: Logger<this> = new Logger({ minLevel: Utils.GLOBAL_LOG_LEVEL, name: 'ProductService' });
  private amplifyService = inject(AmplifyService);
  private amplifyClient = this.amplifyService.getClient();
  // private userService = inject(UserService);

  private contentUtilsService = inject(ContentUtilsService);

  // public async loadUserProducts(): Promise<UserProductData[]> {
  //   const response = await this.amplifyClient.models.UserProduct.list(
  //     { selectionSet: ['product.*'], limit:100},
  //   );
  //   if(response.nextToken){
  //     console.log('There is more...');
  //   }

  //   const productList = Utils.getDataFromResult(response.data, response.errors, 'UserProduct.list');
  //   if(!productList){
  //     return [];
  //   }else{
  //     return productList.map(up => ({
  //       id: up.product.id,
  //       title: up.product.title??'--',
  //       subtitle: up.product.subtitle??'--',
  //       image: up.product.coverImage??'--'
  //     }));
  //   }
  // }

  //=====================
// NEXT =>  Rever funções de lista, consider nextToken (tentar função genérica pra fazer isso?????)
//FINISH DESKTOP APP
//INCORPORATE PUBLISHER (ADMIN MENU?)
//SEE MORE...
//login flows, check, make sure
//no SSO COM GOOGLE ? desktop.jornadas?

  //=====================



  // public async loadUserProducts(userId:string): Promise<UserProductData[]> {
  //   //@ts-ignore
  //   const response = await this.amplifyClient.models.UserProduct.listUserProductByUserIdAndProductId({
  //     userId:userId,
  //   },{
  //     selectionSet: ['product.*'],
  //     // limit: 100,
  //     // nextToken: nextToken,
  //   });
  
  //   const productList = Utils.getDataFromResult(response.data, response.errors, 'UserProduct.list');
  
  //   if (productList && Array.isArray(productList)) {
  //     const mappedProducts = productList.map(up => ({
  //   // @ts-ignore
  //   id: up.product.id,
  //   // @ts-ignore
  //   title: up.product.title ?? '--',
  //   // @ts-ignore
  //   subtitle: up.product.subtitle ?? '--',
  //   // @ts-ignore
  //   image: up.product.coverImage ?? '--'
  //     }));
  //     return mappedProducts;
  //   }else{
  //     return [];
  //   }
  // }

  public async loadUserProducts(userId:string): Promise<UserProductData[]> {
    const api = await getEntitlementsApi();
    const entitlements = await api.entitlementsGet({});
    return entitlements.map(entitlement => ({
      id: entitlement.id,
      title: entitlement.title,
      subtitle: entitlement.subtitle,
      image: entitlement.coverImage
    }));
    
  }


  

  // public async loadUserProducts(): Promise<UserProductData[]> {
  //   let allUserProducts: UserProductData[] = [];
  //   let nextToken: string | undefined = undefined;
  
  //   do {
  //     //@ts-ignore
  //     const response = await this.amplifyClient.models.UserProduct.list({
  //       selectionSet: ['product.*'],
  //       limit: 100,
  //       nextToken: nextToken,
  //     });
  
  //     const productList = Utils.getDataFromResult(response.data, response.errors, 'UserProduct.list');
  
  //     if (productList && Array.isArray(productList)) {
  //       const mappedProducts = productList.map(up => ({
  //         id: up.product.id,
  //         title: up.product.title ?? '--',
  //         subtitle: up.product.subtitle ?? '--',
  //         image: up.product.coverImage ?? '--'
  //       }));
  
  //       allUserProducts.push(...mappedProducts);
  //     }
  
  //     nextToken = response.nextToken;
  //     if (nextToken) {
  //       console.log('Fetching next page...');
  //     }
  
  //   } while (nextToken);
  
  //   return allUserProducts;
  // }
  
  public async listAllAmplifyItems<TModel>(
    listFunction: (params: { limit?: number; nextToken?: string; selectionSet?: string[] }) => Promise<{
      data: any;
      nextToken?: string;
      errors?: any[];
    }>,
    selectionSet?: string[],
    limit: number = 100
  ): Promise<TModel[]> {
    const allItems: TModel[] = [];
    let nextToken: string | undefined = undefined;
  
    do {
      const response = await listFunction({ limit, nextToken, selectionSet });
  
      const items = this.extractItems<TModel>(response.data);
      if (items) {
        allItems.push(...items);
      }
  
      nextToken = response.nextToken;
    } while (nextToken);
  
    return allItems;
  }

  public extractItems<T>(data: any): T[] | null {
  // Assumes that the shape is { ModelName: { items: [...] } }
  if (!data || typeof data !== 'object') return null;

  const modelKey = Object.keys(data)[0];
  const items = data[modelKey]?.items;
  return Array.isArray(items) ? (items as T[]) : null;
}


  public async findProductById(productId: string): Promise<ProductWithStruct | null> {
    this.log.trace(`findProductById [${productId}]`);

    const response = await this.amplifyClient.models.Product.get(
      { id: productId },
      { selectionSet: productWithStruct }
    );
    const product = Utils.getDataFromResult(response.data, response.errors, 'Retrieve product by id');
    
    //SORT PRODUCT MODULES AND CONTENT
    if(product){
      return {
        ...product,
        modules: [...product.modules] // Clone the array to avoid mutating the original
          .sort((a, b) => {
            if (a.displayOrder && b.displayOrder) {
              return a.displayOrder - b.displayOrder;
            } else {
              return 0;
            }
          })
          .map((module) => ({
            ...module, // Clone the module
            contents: [...(module.contents || [])] // Clone the contents array
              .sort((a, b) => {
                if (a.displayOrder && b.displayOrder) {
                  return a.displayOrder - b.displayOrder;
                } else {
                  return 0;
                }
              }),
          })),
      };
    }else{
      return null;
    }
  }

  //Review => Do we need this? We split the work in two functions (status/billing info / struct)
  // private async getProductInfoOrStruct(productId: string): Promise<ProdInfoOrStruct> {
  //   this.log.trace(`getProductInfoOrStruct [${productId}]`);

  //   const user = await this.userUtils.getUserDataFromTokenOrException();

  //   //Get transaction info
  //   const transactionInfo = await this.getTransactionInfo(productId);

  //   if (!transactionInfo) {
  //     // No transactions found, return billing details
  //     this.log.info(`getProductInfoOrStruct => NO transactions found, return billing details user [${user.id}] product [${productId}]`);
  //     return await this.getProductInfoAnswerWithDetails(productId);
  //   }

  //   if (transactionInfo.status.success) {
  //     this.log.info(`getProductInfoOrStruct => Found success transaction => get Product struct`);
  //     const ps = await this.findProductById(productId);
  //     // If a successful transaction exists, product is owned
  //     return this.getProductStruct(ps);

  //   } else if (transactionInfo.status.ongoing && transactionInfo.status.transaction) {
  //     // If an ongoing transaction exists, return details
  //     this.log.info(`getProductInfoOrStruct => Found ONGOING transaction => get info and transact details`);
      
  //     return await this.getProductInfoAnswerWithDetails(
  //       productId,
  //       transactionInfo.status.transaction.id,
  //       transactionInfo.status.transaction.paymentLink
  //     );
  //   } else {
  //     //Not owned, not ongoing (maybe expired?)
  //     return await this.getProductInfoAnswerWithDetails(productId);
  //   }
  // }

  public async createTransactionOrGetUpdatedStatus(productId: string): Promise<
  {
    created:boolean,
    existing:boolean,
    createProfile:boolean,
    paymentOperResult?: PaymentOperationResult
  }
  > {
    this.log.trace(`createTransaction [${productId}]`);


    const url = 'https://jornadas.net/redirect/urlx';


    const request = { type: RequestType.GET_OR_CREATE_PAYMENT_TRANSACTION, productId: productId, payment: { redirectUrl: url } } as BackendRequest;

    const response = await this.amplifyService.sendGenericBackendRequest(request);

    const result = response.paymentOperResult;
    if (!result) { throw Error('No payment operation result!') }

    if (result.paymentOperationStatus === PaymentOperationStatus.TRANSACTION_FOUND) {
      return {
        created:false,
        existing:true,
        createProfile:false,
        paymentOperResult:result
      };
    } else if (result.paymentOperationStatus === PaymentOperationStatus.TRANSACTION_CREATED) {
      return {
        created:true,
        existing:false,
        createProfile:false,
        paymentOperResult:result
      };
    } else if (result.paymentOperationStatus === PaymentOperationStatus.USER_HAS_NO_PAYMENT_PROFILE) {
      return {
        created:false,
        existing:false,
        createProfile:true,
        paymentOperResult:result
      };
    } else {
      throw Error(`Error creating or retrieving transaction status => [${result.error}], status [${result.paymentOperationStatus}]`);
      //Generic error => can't handle!
    }
  }

  public async createPaymentProfile(productId: string, userName:string, taxNumber:string): Promise<{success:boolean,invalidData:boolean}> {
    this.log.trace(`createPaymentProfile [${productId}] [${userName}] [${taxNumber}]`);

    const request = {
      type: RequestType.CREATE_PAYMENT_PROFILE, 
      productId: productId, 
      payment: { userName: userName, taxNumber: taxNumber } 
    } as BackendRequest;

    const response = await this.amplifyService.sendGenericBackendRequest(request);

    const result = response.paymentOperResult;
    if (!result) { throw Error('No payment operation result for creating payment profile') }
    if(response.success===true){
      return {success:true,invalidData:false};
    }else{
      if(result.paymentOperationStatus === PaymentOperationStatus.INVALID_DATA){
        return {success:false,invalidData:true};
      }else{
        throw Error(response.errorMsg);
      }
    }
  }

  /**
   * The start payment process uses this to understand the ext steps.
   * @param productId 
   * @returns 
   */
  public async getTransactionInfo(productId: string): Promise<{status:TransactionStatus,purchaseInfo:ProductPurchaseInfo}> {
    this.log.info(`getTransactionInfo [${productId}]`);

    const purchaseInfo = await this.getBillingDetails(productId);
    if(!purchaseInfo){
      throw Error(`Could not find purchase information for product id [${productId}]`);
    }

    const request = {
      type: RequestType.GET_TRANSACTION_INFO, 
      productId: productId, 
    } as BackendRequest;

    const response = await this.amplifyService.sendGenericBackendRequest(request);

    if(response.success){
      if(response.paymentOperResult){
        const returnData = 
        {
          status:{
            found:true,
            success: response.paymentOperResult.success,
            ongoing: response.paymentOperResult.ongoing??false,
            transaction:{
              id: response.paymentOperResult.transactionId??'',
              paymentLink: response.paymentOperResult.paymentLink??'',
            }
          },
          purchaseInfo:purchaseInfo
        };
        this.log.info(`Return =>`,returnData);
        return returnData;
      }else{return {status:{found:false},purchaseInfo:purchaseInfo}};
    }else{
      throw Error(response.errorMsg??'Unidentified error');
    }
  }


  public async confirmFakePayment(transactionId: string): Promise<boolean> {
    this.log.info(`confirmFakePayment [${transactionId}]`);

    const request = {
      type: RequestType.CONFIRM_FAKE_PAYMENT, 
      payment:{transactionId:transactionId}, 
    } as BackendRequest;

    const response = await this.amplifyService.sendGenericBackendRequest(request);

    if(response.success){
      return true;
    }else{
      return false;
    }
  }
  
  public async hydrateContentCache(contentIds:string[]){
    contentIds.forEach(id=>{
      try{
        this.loadContent(id).then(data=>{
          if(data){
            // console.log(`Content [${id}] loaded into the cache`);
          }
        })
      }catch(error){
        console.log(`Error loading content [${id}] to cache`,error);
      }
    })
  }

  public async loadContent(contentId: string): Promise<ContentWithNotes|null>{
    // var content = await this.contentUtilsService.getContentFromCache(contentId);
    //review cache invalidation strategy
    var content=null
    if(!content){
      const result = await this.amplifyClient.models.Content.get(
        {id:contentId},
        {selectionSet: contentWithNotes}
      );
      content = Utils.getDataFromResult(result.data,result.errors,'Content.get');
      if(content){
        await this.contentUtilsService.cacheContent(contentId,content);
      }
    }
    return content;
  }

  public async loaUserNotes(contentId: string, userId:string): Promise<UserNote[]|null>{
    const result = await this.amplifyClient.models.UserNote.listUserNoteByContentRefIdAndUserId({
      contentRefId: contentId,
      userId: {eq: userId}
    });
    const userNotes = Utils.getDataFromResult(result.data,result.errors,'UserNote.listUserNoteByContentRefIdAndUserId');
    return userNotes;
  }

  //REPLACED BY BOTH FUNCTIONS ABOVE
  public async loadContentDataWithNotes(contentId: string, userId:string): Promise<{content:ContentWithNotes,userNotes:UserNote[]}>{
    // this.log.debug(`Loading content data with notes for content ${contentId}`);

    // const user = this.userService.currentUser();
    // this.log.error('MUST CHANGE HERE, REVIEW!!! COMMENTS');
    const result = await this.amplifyClient.models.Content.get(
      {id:contentId},
      {selectionSet: contentWithNotes}
    );
    // this.log.debug('Loaded content data with notes',result);    

    Utils.handleError(result,'error loading content data with notes');
    
    //If everything was ok, load also the corresponding user notes
    // const ownerString = await this.userService.getOwnerString();
    // this.log.debug(result,`Loading user notes for contet [${contentId}] user id [${user.id}]`);

    const userNotes = await this.amplifyClient.models.UserNote.listUserNoteByContentRefIdAndUserId({
      contentRefId: contentId,
      userId: {eq: userId}
    });
    Utils.handleError(userNotes,`error loading user notes, content id [${contentId}] user id [${userId}]`);

    // this.log.debug(`User notes => ${userNotes.data}`);

    if(result.data && userNotes.data){
      const dataToPublish = {content:result.data,userNotes:userNotes.data};
      return dataToPublish;
    }else{
      throw Error('no data or user notes');
    }
  }



  private async getBillingDetails(productId: string): Promise<ProductPurchaseInfo | null> {
    this.log.info(`getBillingDetails productId [${productId}]`);

    const client = this.amplifyClient;
    const result = await client.models.BillingDetails.get({
      productId: productId
    }, { selectionSet: ['product.title', 'price', 'currency', 'product.coverImage', 'product.subtitle'] });

    const bd = Utils.getDataFromResult(result.data, result.errors, 'BillingDetails.get');
    // if (bd) {
    //   return {
    //     name: bd.product.title ?? '',
    //     price: bd.price,
    //     currency: bd.currency,
    //     coverImage: bd.product.coverImage ?? '',
    //     subTitle: bd.product.subtitle ?? ''
    //   };
    // } else {
    //   return null;
    // }
    return null;
  }

  //HELPER FUNCTIONS

  // private getProductStruct(ps: ProductWithStruct | null) {
  //   if (ps) {
  //     return {
  //       found: true, owned: true, purchaseTransactionPending: false, productWithStruct: ps
  //     } as ProdInfoOrStruct;
  //   } else {
  //     throw Error('Strange, I should have received a product struct');
  //   }
  // }

//   private async getProductInfoAnswerWithDetails(productId: string, paymentTransactionId?: string, paymentLink?: string) {
//     const bd = await this.getBillingDetails(productId)
//     if (bd) {
//       if (paymentTransactionId) {
//         return {
//           found: true, owned: false, purchaseTransactionPending: false, basicDetails: bd,
//           paymentDetails: {
//             paymentTransactionId: paymentTransactionId,
//             paymentLink: paymentLink
//           }
//         } as ProdInfoOrStruct;
//       } else {
//         return {
//           found: true, owned: false, purchaseTransactionPending: false, basicDetails: bd
//         } as ProdInfoOrStruct;
//       }
//     } else {
//       throw Error(`Strange, I shoud have found billing details for product [${productId}]`);
//     }
//   }

}


// export interface ProdInfoOrStruct {
//   found: boolean;
//   owned: boolean;
//   purchaseTransactionPending: boolean;
//   paymentDetails?: {
//     paymentTransactionId: string;
//     paymentLink: string;
//   };
//   basicDetails?: {
//     productName: string;
//     subTitle: string;
//     price: number;
//     currency: string;
//     coverImage: string
//   };
//   productWithStruct?: ProductWithStruct
// };